import { BaseAPI } from 'API/BaseApi';
import { ICorrectionReason } from 'types/corrections/ICorrection';

export const CorrectionsApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listCorrectionReasons: build.query<ICorrectionReason[], void>({
      query: () => ({
        url: '/timber/api/internal/correction-reasons',
        method: 'GET',
      }),
    }),
  }),
});

export const {
    useListCorrectionReasonsQuery,
} = CorrectionsApi;
